import { BaseEntity, getCachedStructureEntity } from ".";
import { IGet_corporations_corporation_id_contracts_200_ok } from "../service/esiclient";
//import { getCachedCharacterEntity } from "./CharacterEntityCache";
import { getCachedStationEntity } from "./StationEntityCache";
import moment from "moment";
import { getCachedCorporationEntity } from "./CorporationEntityCache";

export class CorporationContractEntity extends BaseEntity {
  private _corporation_id: any;
  constructor(id: number, props: any, character_id: number, corporation_id: number) {
    super(id, props);
    this._dataTypeName = "Corporation Contract";
    this._character_id = character_id;
    this._corporation_id = corporation_id;
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    const props: Partial<IGet_corporations_corporation_id_contracts_200_ok> = this.props;
    var entity = await super.toJson();

    // Properties
    if (entity.properties) {
      /*
      if (props.type == "item_exchange" || props.type == "auction" || props.type == "courier") {
        const contract_items: IGet_corporations_corporation_id_contracts_contract_id_items_200_ok[] =
          await getCachedCorporationContractItems(this._id, this._character_id, this._corporation_id);
        if (contract_items !== null && contract_items.length) {
          let items: Excel.EntityCellValue[][] = [];
          for (let i = 0; i < contract_items.length; i++) {
            //The first instance of this can sometimes be undefined, and sometimes is an empty list too, possibly fixed with moving the delete
            if (contract_items[i] !== undefined) {
              const typeEntity = await getCachedTypeEntity(contract_items[i].type_id);
              if (typeEntity !== null) {
                items.push([
                  {
                    type: Excel.CellValueType.entity,
                    text: `${typeEntity.props["name"]} x ${contract_items[i].quantity}`,
                    properties: {
                      type: await typeEntity.toJson(),
                      quantity: {
                        type: Excel.CellValueType.formattedNumber,
                        basicValue: contract_items[i].quantity,
                        numberFormat: "##0",
                      },
                      is_included: {
                        type: Excel.CellValueType.boolean,
                        basicValue: contract_items[i].is_included,
                      },
                    },
                  },
                ]);
              }
            }
          }
          if (items.length) {
            entity.properties["items"] = {
              type: Excel.CellValueType.array,
              elements: items,
            };
          }
        }
      }
      */
      /*
      if (props.type == "auction") {
        const bids: IGet_corporations_corporation_id_contracts_contract_id_bids_200_ok[] =
          await getCachedCorporationContractBids(this._id, this._character_id, this._corporation_id);
        if (bids !== null && bids.length) {
          let bids_list: Excel.EntityCellValue[][] = [];
          for (let i = 0; i < bids.length; i++) {
            if (bids[i] !== undefined) {
              const date_bid = moment(bids[i].date_bid);
              bids_list.push([
                {
                  type: Excel.CellValueType.entity,
                  text: `${bids[i].amount} @ ${bids[i].date_bid}`,
                  properties: {
                    amount: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: bids[i].amount,
                      numberFormat: "##0",
                    },
                    id: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: bids[i].bid_id,
                      numberFormat: "##0",
                    },
                    bidder_id: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: bids[i].bidder_id,
                      numberFormat: "##0",
                    },
                    date_bid: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: date_bid.unix() / 86400 + 25569,
                      numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
                    },
                  },
                },
              ]);
            }
          }
          if (bids_list.length) {
            entity.properties["bids"] = {
              type: Excel.CellValueType.array,
              elements: bids_list,
            };
          }
        }
      }
      */

      // - Id
      delete entity.properties["contract_id"];
      const corporationEntity = await getCachedCorporationEntity(this._corporation_id);
      if (corporationEntity !== null) {
        entity.properties["owner"] = await corporationEntity.toJson();
      }
      if (props.issuer_corporation_id) {
        const issuerCorporationEntity = await getCachedCorporationEntity(props.issuer_corporation_id);
        if (issuerCorporationEntity !== null) {
          entity.properties["issuer_corporation"] = await issuerCorporationEntity.toJson();
          delete entity.properties["issuer_corporation_id"];
        }
      }
      if (props.date_issued) {
        const dateIssued = moment(props.date_issued);
        entity.properties["date_issued"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: dateIssued.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }
      if (props.date_accepted) {
        const dateAccepted = moment(props.date_accepted);
        entity.properties["date_accepted"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: dateAccepted.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }
      if (props.date_completed) {
        const dateCompleted = moment(props.date_completed);
        entity.properties["date_completed"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: dateCompleted.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }
      if (props.date_expired) {
        const dateExp = moment(props.date_expired);
        entity.properties["date_expired"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: dateExp.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }
      // This can be character, corp or alliance so we waste error rates searching directly
      /*
      if (props.issuer_id) {
        const issuerEntity = await getCachedCharacterEntity(props.issuer_id);
        if (issuerEntity !== null) {
          entity.properties["issuer"] = await issuerEntity.toJson();
          delete entity.properties["issuer_id"];
        }
      }
      if (props.acceptor_id) {
        const acceptorEntity = await getCachedCharacterEntity(props.acceptor_id);
        if (acceptorEntity !== null) {
          entity.properties["acceptor"] = await acceptorEntity.toJson();
          delete entity.properties["acceptor_id"];
        }
      }
      if (props.assignee_id) {
        const assigneeEntity = await getCachedCharacterEntity(props.assignee_id);
        if (assigneeEntity !== null) {
          entity.properties["assignee"] = await assigneeEntity.toJson();
          delete entity.properties["assignee_id"];
        }
      }
      */
      if (props.start_location_id) {
        const stationEntity = await getCachedStationEntity(props.start_location_id);
        if (stationEntity !== null) {
          entity.properties["start_location"] = await stationEntity.toJson(true);
          delete entity.properties["start_location_id"];
        } else {
          const structureEntity = await getCachedStructureEntity(props.start_location_id, this._character_id);
          if (structureEntity !== null) {
            entity.properties["start_location"] = await structureEntity.toJson(true);
            delete entity.properties["start_location_id"];
          }
        }
      }
      if (props.end_location_id) {
        const stationEntity = await getCachedStationEntity(props.end_location_id);
        if (stationEntity !== null) {
          entity.properties["end_location"] = await stationEntity.toJson(true);
          delete entity.properties["end_location_id"];
        } else {
          const structureEntity = await getCachedStructureEntity(props.end_location_id, this._character_id);
          if (structureEntity !== null) {
            entity.properties["end_location"] = await structureEntity.toJson(true);
            delete entity.properties["end_location_id"];
          }
        }
      }
      let _title = "";
      if (props.title) {
        _title = props.title + " : ";
      }
      if (props.status && props.type) {
        const status = props.status;
        const type = props.type;
        entity.properties["name"] = {
          type: Excel.CellValueType.string,
          basicValue: _title + type + " (" + status + ")",
        };
        entity.text = _title + type + " (" + status + ")";
      } else {
        entity.properties["name"] = {
          type: Excel.CellValueType.string,
          basicValue: "Contract",
        };
        entity.text = "Contract";
      }
    }

    // Layouts
    entity.layouts = {
      card: {
        // title: { property: "name" },
      },
    };

    // - Image
    if (
      entity.layouts &&
      entity.layouts.card &&
      entity.properties &&
      Object.prototype.hasOwnProperty.call(entity.properties, "image")
    ) {
      entity.layouts.card.mainImage = { property: "image" };
    }

    return entity;
  }
}
